// CARO. Casa de estilo — COLORIMETRY ME!: the game's own card (1200×630 JPEG built by
// `npm run og:colorimetry`), og:image of /estudio-de-estilo/colorimetria and the image of its link on /caro/servicios.
// Kept apart from ./share on purpose: it reads only og.json, so the services page does not load the
// game's copy.

import ogJson from '@/content/colorimetry/og.json';
import type { Locale } from '@/types';

/** The game card (/media/... URL) in a language, once `npm run og:colorimetry` built it. */
export function gameCard(locale: Locale): string | undefined {
  return (ogJson as { game?: Partial<Record<Locale, string>> }).game?.[locale];
}

type StyleCards = Partial<Record<'silhouette' | 'face', { game?: Partial<Record<Locale, string>>; results?: Partial<Record<Locale, Record<string, string>>> }>>;

/**
 * The card of the silhouette or face test (`id` undefined) or of one of its results (silhouette or face
 * id), in a language, once `npm run og:colorimetry` built it.
 */
export function styleCard(game: 'silhouette' | 'face', locale: Locale, id?: string): string | undefined {
  const cards = (ogJson as { style?: StyleCards }).style?.[game];
  return id ? cards?.results?.[locale]?.[id] : cards?.game?.[locale];
}
